import { ClickAwayListener, Paper, Popper, styled } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { useCallback } from "react";
import type { KeyboardEvent, MutableRefObject, ReactNode } from "react";

const GridPanelRoot = styled(Popper, {
    name: "MuiDataGrid",
    slot: "Panel",
    overridesResolver: (props, styles) => styles.panel,
})(({ theme }) => ({
    zIndex: (theme as any).zIndex.modal,
}));

const GridPaperRoot = styled(Paper, {
    name: "MuiDataGrid",
    slot: "Paper",
    overridesResolver: (props, styles) => styles.paper,
})(({ theme }) => ({
    backgroundColor: "#FFFFFF",
    minWidth: 300,
    maxHeight: 450,
    display: "flex",
    maxWidth: `calc(100vw - ${theme.spacing(0.5)})`,
    overflow: "auto",
}));

type Props = {
    toolbarRef: MutableRefObject<any>;
    children?: ReactNode;
    className?: string;
    [key: string]: any;
};

export default function ConquestModeGridPanel({ toolbarRef, children, ...props }: Props) {
    const apiRef = useGridApiContext();

    const handleClickAway = useCallback(() => {
        apiRef.current.hidePreferences();
    }, [apiRef]);

    const handleKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                apiRef.current.hidePreferences();
            }
        },
        [apiRef]
    );

    const open = (apiRef.current as any)?.state?.preferencePanel?.open;
    const anchorEl = toolbarRef.current;

    if (!anchorEl) return null;

    return (
        <GridPanelRoot
            {...props}
            as={undefined}
            anchorEl={anchorEl}
            open={open}
            placement="bottom-start"
        >
            <ClickAwayListener
                mouseEvent="onPointerUp"
                touchEvent={false}
                onClickAway={handleClickAway}
            >
                <GridPaperRoot elevation={8} onKeyDown={handleKeyDown}>
                    {children}
                </GridPaperRoot>
            </ClickAwayListener>
        </GridPanelRoot>
    );
}